import { collection, where } from 'firebase/firestore';
import { firestore } from 'firebaseService/firebase';
import FirebaseFirestoreService from 'firebaseService/firebaseFirestore';

class UserNotifyFirestoreService extends FirebaseFirestoreService {
  static collectionPath = 'userNotify';
  static collection = collection(firestore, this.collectionPath);

  static async createOrReactivateUserNotify(values) {
    try {
      const constrains = [where('uid', '==', values.uid)];
      const exist = await this.findDoc(this.collection, constrains);
      if (exist) {
        const result = await this.reactivateUserNotify(exist.id);
        return { success: true, result };
      } else {
        const result = await this.addDoc(this.collection, values);
        return { success: true, result };
      }
    } catch (error) {
      console.error(error);
      return { success: false, error };
    }
  }

  static async deleteUserNotify(documentId) {
    try {
      return await this.deleteDoc(this.collectionPath, documentId);
    } catch (error) {
      return { success: false, error };
    }
  }

  static async reactivateUserNotify(documentId) {
    try {
      return await this.reactivateDoc(this.collectionPath, documentId);
    } catch (error) {
      return { success: false, error };
    }
  }

  static async getUserNotify() {
    try {
      const constrains = [where('isActive', '==', true)];
      return await this.getAllDocs(this.collection, constrains);
    } catch (error) {
      return { success: false, error };
    }
  }

  static subscribeToUserNotify(callBack) {
    try {
      const constrains = [where('isActive', '==', true)];

      const unsubscibe = this.subscribeToAllDocs(this.collection, constrains, callBack);
      return unsubscibe;
    } catch (error) {
      return { success: false, error };
    }
  }
}

export default UserNotifyFirestoreService;
